import { useContext, useEffect, useState } from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import '../studiesPage/studyPage.css'
import { Typography } from '@mui/material';
import axios from 'axios';
import UserContext from '../../Context/User/userContext';


const CloseStudyCard = () => {
  const [data, setData] = useState([]);
  // Bearer Token
  const token = localStorage.getItem('token');
  const tokenValue = token ? token.slice(1, token.length - 1) : "";

  const { user, setUser } = useContext(UserContext);

  const getData = () => {
    axios.post(`https://research-mate-b35a10757d5a.herokuapp.com/api/adminStudy/specific`, {
      status: 'close'
    }, {
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${tokenValue}`
      }
    })
      .then(res => {
        const response = res.data.data
        setData(response);
      })
      .catch(error => {
        console.log(error);
      })
  }

  useEffect(() => {
    if (user) {
      getData()
    }
  }, [user])
  return (
    <>
      <div className='p-2'>
      <h4 style={{color:'rgb(23 131 131)'}}>Close Studies</h4>
        <div >
          {
            data.length === 0 ?
            <div className='d-flex justify-content-center align-items-center'>
            <img width={500} height={500} src={require('../../images/nodataImg.webp')} alt="No Data Available" />
            </div>
              :
              data.map((v, i) => (
                <Card key={v._id}>
                  <Card.Body>
                    <Row>
                      <Col style={{ maxWidth: '150px' }}>
                        <h6>Study Code</h6>
                        <p className="ellipsis-text" title={v.studyCode}>{v.studyCode}</p>
                      </Col>
                      <Col style={{ maxWidth: '300px' }}>
                        <h6>Study Title</h6>
                        <p className="ellipsis-text" title={v.title}>{v.title}</p>
                      </Col>
                      <Col style={{ maxWidth: '300px' }}>
                        <h6>Sponsor/CRO</h6>
                        <p className="ellipsis-text" title={v.sponsorName}>{v.sponsorName}/{v.CRO}</p>
                      </Col>
                      <Col style={{ maxWidth: '300px' }}>
                        <h6>Active Date</h6>
                        <p className="ellipsis-text" title={v.activationDate}>{v.activationDate}</p>
                      </Col>
                      <Col style={{ maxWidth: '300px' }}>
                        <h6>Study Manager</h6>
                        <p className="ellipsis-text" title={v.manager}>{v.manager}</p>
                      </Col>
                      <Col style={{ maxWidth: '300px' }}>
                        <h6>PI</h6>
                        <p className="ellipsis-text" title={v.pi}>{v.pi}</p>
                      </Col>
                      <Col style={{ maxWidth: '150px' }}>
                        <h6>Status</h6>
                        <p className="ellipsis-text" title={v.status}>{v.status}</p>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              ))
          }

        </div>
      </div>
    </>
  );
};

export default CloseStudyCard;
